/**
 * Lucide icon *data* for MorphIcon — not lucide-react components.
 *
 * Morphicons consumes IconNode arrays from the vanilla `lucide` package. Keep every
 * `lucide` import in this file so the rest of the app only needs `lucide-react`.
 */
import {
  ArrowDown,
  ArrowUp,
  Building2,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronsLeft,
  ChevronsRight,
  ChevronsUpDown,
  Check,
  Circle,
  CircleAlert,
  Contact,
  CreditCard,
  FileText,
  Image,
  MapPin,
  Megaphone,
  MessageSquarePlus,
  MessageSquareText,
  Minus,
  Pencil,
  Save,
  Share2,
  Sparkles,
  Tags,
  Upload,
  UserPen,
  Users,
  type IconNode,
} from 'lucide'

import type { SectionId } from '@/lib/supplier/types'

export {
  ArrowDown,
  ArrowUp,
  Building2,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronsLeft,
  ChevronsRight,
  ChevronsUpDown,
  Check,
  Circle,
  CircleAlert,
  Contact,
  FileText,
  MessageSquarePlus,
  MessageSquareText,
  Minus,
  Pencil,
  Save,
  Share2,
  UserPen,
  type IconNode,
}

/** Section icons for the partner profile edit rail, keyed by section id. */
export const SUPPLIER_SECTION_RAIL_ICONS: Partial<Record<SectionId, IconNode>> = {
  profile_details: Building2,
  contact_information: Contact,
  commission_contract: FileText,
  commission_uploads: Upload,
  payment_information: CreditCard,
  partner_contacts: Users,
  selling_points: Megaphone,
  amenities: Sparkles,
  destinations: MapPin,
  media: Image,
  content_tagging: Tags,
}
